import img1 from './images/background/gym-img-3.jpg';
import img2 from  './images/background/video-img-1.jpg';
import img3 from './images/background/vishal.jpg';

 const Hero =()=>{
    return(
        <>
        <section class="container-fluid" id="herosection">
            <section className="continer">
            <div class="row">
            
            <div class="col-12">
                <div id="carouselExampleDark" class="carousel carousel-dark slide" data-bs-ride="carousel">
                    <div class="carousel-indicators">
                        <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" class="active"
                            aria-current="true" aria-label="Slide 1"></button>
                        <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1"
                            aria-label="Slide 2"></button>
                        <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2"
                            aria-label="Slide 3"></button>
                    </div>
                    <div class="carousel-inner">
                        <div class="carousel-item active" data-bs-interval="10000">
                            <img src={img1}  class="d-block w-100 h-100" alt="image not found"/>
                            <div class="carousel-caption d-none d-md-block">
                                <h5>PUMP YOUR MUSCLES</h5>
                                <p>Accumsan vulputate sed id blandit duis pellentesque nullam daim purus</p>
                            </div>
                        </div>
                        <div class="carousel-item" data-bs-interval="2000">
                            <img src={img2}  class="d-block w-100 h-100" alt="..."/>
                            <div class="carousel-caption d-none d-md-block">
                                <h5>Doing Sports</h5>
                                <p>Accumsan vulputate sed id blandit duis pellentesque nullam daim purus</p>
                            </div>
                        </div>
                        <div class="carousel-item">
                            <img src={img3} class="d-block w-100 h-100" alt="..."/>
                            <div class="carousel-caption d-none d-md-block">
                                <h5>Shape Your Perfect Body</h5>
                                <p>Some representative placeholder content for the third slide.</p>
                            </div>
                        </div>
                    </div>
                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark"
                        data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleDark"
                        data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div>
                </div>
                
                </div>
                </section>
    </section>
        
        </>

        
    );
 }
 export default Hero;